"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Amount() {
  try {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['label']
    }, "\u0421\u0443\u043C\u043C\u0430 \u0437\u0430\u043A\u0430\u0437\u0430"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['fields']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['field']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      "data-locator": "amountFrom.input",
      name: "amountFrom"
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['separator']
    }, "-"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['field']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      "data-locator": "amountTo.input",
      name: "amountTo"
    }))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Amount;
exports["default"] = _default;